export default __webpack_public_path__ + "static/media/MIchelle Bridges_12WBT_Purchase Page_Desktop.280755b2.png";